import { ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import { Text } from '@atlaskit/primitives-next';

import { RESERVED_ORG_IDS } from '@/state';
import { CustomerDomainOrg } from '@/state/types';

import { messages } from '../messages';

export const OrgSelectorItemMessage = ({ org }: { org: CustomerDomainOrg }): ReactNode => {
	switch (org.orgId) {
		case RESERVED_ORG_IDS.NO_ORG:
			return (
				<Text>
					<FormattedMessage {...messages.orgSelectorDropdownNoOrgForOrgAdmin} />
				</Text>
			);
		case RESERVED_ORG_IDS.OTHER_ORGS:
			return (
				<Text>
					<FormattedMessage {...messages.orgSelectorDropdownOtherOrgsForOrgAdmin} />
				</Text>
			);
		default:
			return <Text>{org.orgName}</Text>;
	}
};
